import DeactivateButton from './component';

export default DeactivateButton;
